<template>
  <el-row class="orderfilter_framework">
    <label>{{title === '' ? '下单时间' : title}}</label>
    <el-date-picker v-model="dateRange" type="daterange" unlink-panels :clearable="false" range-separator="至"
                    start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                    @change="changeFilteringForm()"
                    :default-time="['00:00:00', '23:59:59']">>
    </el-date-picker>
  </el-row>
</template>

<script>
  export default {
    name: "OrderFilter",
    data() {
      return {
        //日期选择器快捷键
        pickerOptions: {
          shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
            {
              text: "最近一年",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90 * 4);
                picker.$emit("pick", [start, end]);
              },
            },
          ],
        },
        dateRange: [(new Date()).getTime() - 3600 * 1000 * 24 * 7, new Date().getTime()],
        filteringForm: {
          startTime: (new Date()).getTime() - 3600 * 1000 * 24 * 7,
          endTime: new Date().getTime(),
        }, //当前筛选框值
      }
    },
    props: {
      title: {
        type: String,
        default: '',
        required: false,
      },
    },
    created() {
      // console.log(this.dateRange);
    },
    watch: {
      filteringForm: {
        deep: true,
        handler: function () {
          this.$emit("changeData", this.filteringForm);
        },
      },
    },
    methods: {
      // 统计项筛选框变化触发
      async changeFilteringForm() {
        this.ensembleFilteringForm();
      },
      // 组装FilteringForm
      ensembleFilteringForm() {
        // 对时间进行处理
        let date = this.dateRange.map((item) => item.getTime());
        this.filteringForm.startTime = date[0];
        this.filteringForm.endTime = date[1];
      }
    }
  }
</script>

<style>
  .filteringform_framework {
    margin: 20px;
    text-align: left;
  }

  label {
    font-size: 16px;
    padding-left: 0;
    padding-right: 20px;
  }
</style>
